import { lazy } from 'react';
import { createBrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import { AuthCallback, AuthGuard } from '@os/auth-client/react';
import { AppShell } from '@/layout/AppShell';
import { addonWeb } from '@/addons/catalog';
import { AddonGate } from '@/addons/AddonGate';

// Pages are lazy (§51).
const Dashboard = lazy(() => import('@/pages/dashboard/DashboardPage'));
const DailyEntry = lazy(() => import('@/pages/entry/DailyEntryPage'));
const Dispatch = lazy(() => import('@/pages/dispatch/DispatchPage'));
const Invoices = lazy(() => import('@/pages/invoices/InvoicesPage'));
const Products = lazy(() => import('@/pages/products/ProductsPage'));
const Purchases = lazy(() => import('@/pages/purchases/PurchasesPage'));
const FreeIssues = lazy(() => import('@/pages/free/FreeIssuesPage'));
const Damage = lazy(() => import('@/pages/damage/DamagePage'));
const Network = lazy(() => import('@/pages/network/NetworkPage'));
const Salesmen = lazy(() => import('@/pages/salesmen/SalesmenPage'));
const Reports = lazy(() => import('@/pages/reports/ReportsPage'));
const Users = lazy(() => import('@/pages/users/UsersPage'));
const Company = lazy(() => import('@/pages/company/CompanyPage'));
const Settings = lazy(() => import('@/pages/settings/SettingsPage'));
const Addons = lazy(() => import('@/pages/settings/AddonsPage'));

function Callback() {
  const nav = useNavigate();
  return <AuthCallback onComplete={(to) => nav(to, { replace: true })} />;
}

const addonRoutes = addonWeb.flatMap((m) => m.routes.map((r) => ({ ...r, element: <AddonGate addonId={m.id}>{r.element}</AddonGate> })));

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <Callback /> },
  {
    path: '/',
    element: <AuthGuard><AppShell /></AuthGuard>,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'entry', element: <DailyEntry /> },
      { path: 'entry/:orderId', element: <DailyEntry /> },
      { path: 'dispatch', element: <Dispatch /> },
      { path: 'invoices', element: <Invoices /> },
      { path: 'invoices/:invoiceId', element: <Invoices /> },
      { path: 'products', element: <Products /> },
      { path: 'products/:productId', element: <Products /> },
      { path: 'purchases', element: <Purchases /> },
      { path: 'purchases/:grnId', element: <Purchases /> },
      { path: 'free', element: <FreeIssues /> },
      { path: 'damage', element: <Damage /> },
      { path: 'network', element: <Network /> },
      { path: 'salesmen', element: <Salesmen /> },
      { path: 'reports', element: <Reports /> },
      { path: 'users', element: <Users /> },
      { path: 'company', element: <Company /> },
      { path: 'settings/addons', element: <Addons /> },
      { path: 'settings', element: <Settings /> },
      ...addonRoutes,
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
